module.exports = __webpack_public_path__ + "img/image1.de07b5c3.jpg";